import React from 'react';

export default function Address() {
  return (
    <svg viewBox="0 0 8.4666669 8.4666669">
      <g transform="translate(0 -288.53332)">
        <path d="M15.996094.99609375c-6.0632836 0-10.9980445 4.93673065-10.9980471 11.00000025C4.9980431 22.664831 15.376953 30.775391 15.376953 30.775391c.364612.290384.881482.290384 1.246094 0 0 0 10.380882-8.11056 10.380859-18.779297C27.003893 5.9328244 22.059377.99609375 15.996094.99609375Zm0 6.00195315c2.749573 0 5.00585 2.2484784 5.005859 4.9980471C21.001971 14.7457 18.745685 17 15.996094 17s-4.998064-2.2543-4.998047-5.003906c.000009-2.7495687 2.248474-4.9980471 4.998047-4.9980471z"transform="matrix(.26458 0 0 .26458 0 288.53332)"/>
      </g>
    </svg>
  );
}